import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const ZONES = ["Milano città", "Hinterland nord", "Hinterland sud", "Hinterland est", "Hinterland ovest", "Monza e Brianza"];

const Cell = ({ className = "", children, i = 0, testid }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className={`relative overflow-hidden rounded-[28px] border border-white/10 ${className}`}
    data-testid={testid}
  >
    {children}
  </motion.div>
);

const Photo = ({ src, alt }) => (
  <img src={src} alt={alt} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
);

export const Zones = () => (
  <section id="zone" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <p className="eyebrow">Dove lavoriamo</p>
      <h2 className="mt-5 max-w-2xl font-display text-4xl font-bold leading-[1] tracking-tight text-white sm:text-5xl">Milano e tutto quello che c'è intorno.</h2>
      <div className="mt-14 grid auto-rows-[minmax(240px,auto)] grid-cols-1 gap-4 md:grid-cols-4">
        <Cell className="group md:col-span-2 md:row-span-2" testid="bento-milano">
          <Photo src="/img/galleria.jpg" alt="Milano, Galleria Vittorio Emanuele" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#070B14] via-[#070B14]/20 to-transparent" />
          <div className="absolute bottom-0 p-7">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--cyan)]">Zona principale</p>
            <p className="mt-2 font-display text-4xl font-bold text-white sm:text-5xl">Milano</p>
          </div>
        </Cell>
        <Cell className="bg-[var(--cyan)] p-7 md:col-span-2" i={1} testid="bento-zone-list">
          <MapPin className="h-6 w-6 text-black" />
          <div className="mt-5 flex flex-wrap gap-2">
            {ZONES.map((z) => (
              <span key={z} className="rounded-full border border-black/25 px-3 py-1.5 text-sm font-semibold text-black">{z}</span>
            ))}
          </div>
          <p className="mt-4 text-sm text-black/75">Sei fuori zona? Scrivici lo stesso.</p>
        </Cell>
        <Cell className="group" i={2} testid="bento-civile">
          <Photo src="/img/uffici.jpg" alt="Pulizia di una scrivania" />
          <div className="absolute inset-0 bg-[#070B14]/45" />
          <p className="absolute bottom-6 left-6 font-display text-2xl font-bold text-white">Civile</p>
        </Cell>
        <Cell className="group" i={3} testid="bento-industriale">
          <Photo src="/img/magazzino.jpg" alt="Magazzino industriale" />
          <div className="absolute inset-0 bg-[#070B14]/45" />
          <p className="absolute bottom-6 left-6 font-display text-2xl font-bold text-white">Industriale</p>
        </Cell>
      </div>
    </div>
  </section>
);
